// FLAGS: none
// Two cross-cutting calls with no domain of their own: the operator's UI language and the static-asset base URLs.
import { Users } from "@src/api/v1/Users";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { useQuery } from "@tanstack/react-query";
import { Resources } from "@src/api/v1/Resources";

export const updateUserLanguage = (languageCode: string) =>
  new Users(OpenUpHttpClient).updateUserLanguage({}, { languageCode });

export const useStaticResourcesQuery = () =>
  useQuery({
    queryKey: ["static-reources"],
    queryFn: async () => new Resources(OpenUpHttpClient).getResourcesUrls(),
  });
